import { useOptionChainContext } from '../../../context/OptionChainContext';
import { useOptionChainScreenContext } from '../context/OptionChainContext';
import { CustomDropdown } from './CustomDropdown';
import Execute from "../../../images/Builder/execute.svg";
import ExecuteDark from "../../../images/Builder/execute_dark.svg";
import { useTheme } from "../../../context/ThemeContext";

export default function BasketBottom({ showConfirmModal }) {
    const { lotx, handleLotxChange, selectedSymbol, marketType, handleMarketTypeChange } = useOptionChainScreenContext();
    const { theme } = useTheme();
    return (
        <div className="flex items-center gap-2 justify-between p-4 pt-3 border-t border-n100 border-opacity-30">
            <div className="gap-3 flex">
                <CustomDropdown
                    label="LOT X:"
                    options={[...Array(15)].map((_, i) => i + 1)}
                    value={lotx}
                    onChange={handleLotxChange}
                />
                <CustomDropdown
                    options={["NRML", "MIS"]}
                    value={marketType}
                    onChange={handleMarketTypeChange}
                />
            </div>
            <button className="text-[10px] px-6 py-2 bg-swipe-button text-p400 rounded flex gap-2"
                onClick={showConfirmModal}
            >
                <img src={theme === "dark" ? ExecuteDark : Execute} alt="Execute icon" className="w-4 h-4" />
                <p>Execute</p>
            </button>
        </div>
    );
}
